import { isAvailable, getUnavailableModifiers } from '~utils/product';

export const getFilteredItems = ({ cartItems, menu, searchModifiers = false, futureOrder }) => {
  if (cartItems && menu) {
    return searchModifiers
      ? cartItems.reduce(
          (unavailableModifiers, product) => [
            ...unavailableModifiers.concat(getUnavailableModifiers(product, menu))
          ],
          []
        )
      : cartItems?.filter((product) => !isAvailable(product, menu, futureOrder));
  }
};
